module.exports = __webpack_public_path__ + "img/covve-scan.40f9889d.png";